import design from './en-US/design';
import menu from './en-US/menu';
import mockup from './en-US/mockup';
import pages from './en-US/pages';

export default {
  'navBar.lang': 'Languages',
  ...menu,
  ...pages,
  ...mockup,
  ...design,
};
